import { Component, ReactNode } from 'react';
import { CHUNK_RELOAD_COOLDOWN_KEY, isChunkLoadError } from '@/utils/lazyWithReload';

interface Props {
  children: ReactNode;
}

interface State {
  error: unknown;
}

export class ChunkErrorBoundary extends Component<Props, State> {
  // eslint-disable-next-line react/state-in-constructor
  state: State = { error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { error };
  }

  // eslint-disable-next-line class-methods-use-this
  private handleReload = () => {
    try {
      sessionStorage.removeItem(CHUNK_RELOAD_COOLDOWN_KEY);
    } catch {
      // sessionStorage may be unavailable in private mode
    }
    const url = new URL(window.location.href);
    url.searchParams.set('_v', Date.now().toString());
    window.location.replace(url.toString());
  };

  render() {
    const { error } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    if (!error) return this.props.children;

    if (!isChunkLoadError(error)) throw error;

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          textAlign: 'center',
          fontFamily: 'Poppins, system-ui, sans-serif',
          color: '#1f1f1f'
        }}>
        <h1 style={{ fontSize: '24px', margin: '0 0 12px' }}>A new version is available</h1>
        <p style={{ fontSize: '16px', margin: '0 0 24px', maxWidth: '480px' }}>
          We&apos;ve updated the dashboard. Please reload to continue.
        </p>
        <button
          type="button"
          onClick={this.handleReload}
          style={{
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            background: '#6c5ce7',
            color: '#fff',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer'
          }}>
          Reload now
        </button>
      </div>
    );
  }
}

export default ChunkErrorBoundary;
